import type {
  Params,
  Program,
  ProgramListResponse,
  UpdateProgramResponse,
} from '@/domains/system-management/types/program';
import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';

export const programApi = {
  // Get program list
  getPrograms: async (params: Params): Promise<ProgramListResponse[]> => {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        queryParams.append(key, value.toString());
      }
    });
    const url = `${URLS.BACK_DSH}${APIS.programList(queryParams.toString())}`;
    return request.get(url);
  },

  // Get program details
  getProgram: async (id: string): Promise<Program> => {
    const url = `${URLS.BACK_DSH}${APIS.detailProgram(id)}`;
    return request.get(url);
  },

  // Create program
  createProgram: async (data: Partial<Program>): Promise<{ id: string }> => {
    const url = `${URLS.BACK_DSH}${APIS.createUpperProgram}`;
    return request.post(url, data);
  },

  // Create lower program
  createLowerProgram: async (data: Partial<Program>): Promise<{ id: string }> => {
    const url = `${URLS.BACK_DSH}${APIS.createLowerProgram}`;
    return request.post(url, data);
  },

  // Update program
  updateProgram: async (id: string, data: Partial<Program>): Promise<UpdateProgramResponse> => {
    const url = `${URLS.BACK_DSH}${APIS.updateUpperProgram(id)}`;
    return request.put(url, data);
  },

  // Update program
  updateLowerProgram: async (
    id: string,
    data: Partial<Program>
  ): Promise<UpdateProgramResponse> => {
    const url = `${URLS.BACK_DSH}${APIS.updateLowerProgram(id)}`;
    return request.put(url, data);
  },

  // Delete program
  deleteProgram: async (id: string): Promise<void> => {
    const url = `${URLS.BACK_DSH}${APIS.deleteProgram(id)}`;
    return request.delete(url, id);
  },
};
